import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setShowSignupPopup } from 'redux-thunk/redux/slices/gameSetting.slice'
import { ROUTE_PATHS } from 'constants/index'
import { ClutchEcosystemIcon } from 'components/ui-kit/Icons/svg/index'
import ContentHeader from 'components/ui-kit/ContentHeader/index'
import CasinoCardSlider from 'components/ui-kit/CasinoCardSlider'
import { openInfoToaster } from 'helpers/toaster.helpers'
import { Gamepad2, Tv2, Bitcoin } from 'lucide-react'

const ClutchEcosystem = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { loginData } = useSelector((state) => state.auth)
  // const history = useHistory()
  // const { handleLoginBeforeRedirect } = useLoginBeforeRedirect()

  const handleClickRegister = () => {
    if (!loginData?.accessToken) {
      dispatch(setShowSignupPopup(true))
    }
  }

  const handleComingSoon = useCallback(() => {
    openInfoToaster({ message: 'Coming soon' })
  })

  const clutchEcoSystemItems = useMemo(() => [
    {
      cardClassName: 'casino-card-sea',
      text: `<div>10,000+</div><span class='text-gradient-two d-inline-block'>${t('casino')}</span> ${t('games')}`,
      subText: t('ecosystemJoinTheFun'),
      icon: <Gamepad2 size={88} color='#8FFFEE' strokeWidth={1.2} />,
      linkText: t('playNow'),
      isTextGradient: false,
      isTextNewLine: true,
      to: ROUTE_PATHS.CASINO,
      textSize: 'big'
    },
    {
      cardClassName: 'casino-card-gold',
      text: `<div>${t('liveCasino')}</div><span class='text-gradient-live'>24/7</span>`,
      subText: t('ecosystemCasino24x7'),
      icon: <Tv2 size={88} color='#FFC84C' strokeWidth={1.2} />,
      linkText: t('joinNow'),
      isTextGradient: false,
      isTextNewLine: true,
      to: ROUTE_PATHS.LIVE_CASINO || ROUTE_PATHS.CASINO,
      textSize: 'big'
    },
    {
      cardClassName: 'casino-card-purple',
      text: `Casino Meets <span class='text-gradient-three'>${t('crypto')}</span>`,
      subText: t('ecosystemTrade'),
      icon: <Bitcoin size={88} color='#C776FF' strokeWidth={1.2} />,
      linkText: t('startBetting'),
      isTextGradient: false,
      isTextNewLine: true,
      to: `${ROUTE_PATHS.CRYPTO_ABT}`,
      textSize: 'big'
    }
  ], [loginData?.accessToken])


  return (
    <section className='pb-4'>
      <ContentHeader
        title={t('nextEcosystem')}
        subtitle={!loginData?.accessToken ? t('registerNow') : ''}
        Icon={ClutchEcosystemIcon}
        subtitleOnClickHandler={handleClickRegister}
      />
      <div className='slide-wrap'>
        <CasinoCardSlider items={clutchEcoSystemItems} />
      </div>
    </section>
  )
}

export default React.memo(ClutchEcosystem)
